import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Card, Checkbox, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { API_BASE_URL, API_ENDPOINTS } from '../../api/config';
import './Login.css';

const REMEMBERED_LOGIN_KEY = 'shengyu_admin_remembered_login';

const Login: React.FC = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    try {
      const remembered = JSON.parse(localStorage.getItem(REMEMBERED_LOGIN_KEY) || '{}');
      if (remembered.email && remembered.password) {
        form.setFieldsValue({
          email: remembered.email,
          password: remembered.password,
          rememberPassword: true,
        });
      }
    } catch {
      localStorage.removeItem(REMEMBERED_LOGIN_KEY);
    }
  }, [form]);

  // 登录
  const onFinish = async (values: any) => {
    try {
      setLoading(true);
      const response = await fetch(`${API_BASE_URL}${API_ENDPOINTS.system_app.loginByPassword}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: values.email,
          password: values.password,
        }),
      });

      const responseBody = await response.text();
      let data: any = {};
      if (responseBody) {
        try {
          data = JSON.parse(responseBody);
        } catch {
          data = {};
        }
      }

      if (response.ok) {
        // 保存 token 和用户信息
        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));
        if (values.rememberPassword) {
          localStorage.setItem(REMEMBERED_LOGIN_KEY, JSON.stringify({
            email: values.email,
            password: values.password,
          }));
        } else {
          localStorage.removeItem(REMEMBERED_LOGIN_KEY);
        }
        
        message.success(data.message || '登录成功');
        // 强制刷新页面以更新路由状态
        window.location.href = '/dashboard';
      } else {
        const detail = Array.isArray(data.detail) ? data.detail[0]?.msg : data.detail;
        message.error(detail || (response.status >= 500 ? '服务暂时不可用，请稍后重试' : '登录失败'));
      }
    } catch (error) {
      message.error('网络错误，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <Card className="login-card" bordered={false}>
        <div className="login-header">
          <h1>声屿管理后台</h1>
          <p>Admin Management System</p>
        </div>
        <Form
          form={form}
          name="login"
          onFinish={onFinish}
          initialValues={{ rememberPassword: false }}
          autoComplete="on"
          size="large"
        >
          <Form.Item
            name="email"
            rules={[
              { required: true, message: '请输入账号或邮箱' }
            ]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="账号或邮箱"
              autoComplete="username"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              { required: true, message: '请输入密码' },
              { min: 6, message: '密码至少6位' }
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="密码"
              autoComplete="current-password"
            />
          </Form.Item>

          <Form.Item
            name="rememberPassword"
            valuePropName="checked"
            className="remember-password-item"
          >
            <Checkbox>记住密码</Checkbox>
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block loading={loading}>
              登录
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Login;
